import React, { Component } from 'react';
import Calendar from 'ui/techPage/components/calendar';
import Select from 'ui/techPage/components/select';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

import { runCommand } from 'redux/app/actionCreators';

import styles from './styles';

const {
    CommandContainer,
    CommandInteractionContainer,
    CommandElementContainer,
    Label,
    LabelText,
} = styles;

const EMAIL_REGEXP = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

class Command extends Component {
    constructor(props) {
        super(props);
        // Задача - установить значения по-умолчанию!!!
        const { command } = this.props;
        command.commandParams.forEach(param => {
            const idx = command.commandParams.indexOf(param);
            switch (param.type) {
                case 'date':
                    if (param.name === 'from') {
                        command.commandParams[idx].value = dayjs().add(-1, 'day').format('YYYY/MM/DD');
                        command.commandParams[idx].default = dayjs().add(-1, 'day').format('YYYY/MM/DD');
                    } else if (param.name === 'to') {
                        command.commandParams[idx].value = dayjs().format('YYYY/MM/DD');
                        command.commandParams[idx].default = dayjs().format('YYYY/MM/DD');
                    }
                    break;
                case 'checkbox':
                    if (param.value === 'true') {
                        command.commandParams[idx].value = true;
                    } else if (param.value === 'false') {
                        command.commandParams[idx].value = false;
                    }
                    break;
                default:
                    break;
            }
        });

        this.state = {
            command,
        };
    }

    handleCalendar = (e, commandParameter) => {
        if (commandParameter.name === 'from' && dayjs(commandParameter.default).toDate().getTime() < e.getTime()) {
            alert('Начало периода не может быть позже вчерашнего дня!!!');
            return;
        }
        // Здесь надо усложнить проверку. Т. к. конец периода не может быть раньше начала. Но не может быть позже сегодняшнего дня
        const { state } = this;
        if (commandParameter.name === 'to') {
            if (dayjs(commandParameter.default).toDate().getTime() < e.getTime()) {
                alert('Конец периода не может быть позже сегодняшнего дня!!!');
                return;
            }
            const from = state.command.commandParams.filter(param => param.name === 'from')[0];
            if (dayjs(from.value).toDate().getTime() > e.getTime()) {
                alert('Конец периода не может быть раньше его начала.');
                return;
            }
        }

        const idx = state.command.commandParams.indexOf(commandParameter);
        state.start = e;
        state.command.commandParams[idx].value = dayjs(e).toDate();
        this.setState({
            ...state,
        });
    };

    handleCheckbox = (commandParameter) => {
        const { state } = this;
        const idx = state.command.commandParams.indexOf(commandParameter);
        state.command.commandParams[idx].value = !state.command.commandParams[idx].value;
        this.setState({
            ...state,
        });
    };

    handleMerchantChange = (e, commandParameter) => {
        const { state } = this;
        const idx = state.command.commandParams.indexOf(commandParameter);
        state.command.commandParams[idx].value = e.target.value;
        this.setState({
            ...state,
        });
    };

    handleClick = () => {
        const { command } = this.state;
        if (command.command === 'test:gen:payment') {
            if (command.commandParams[0].value !== 'fake' && command.commandParams[0].value.search(EMAIL_REGEXP) === -1) {
                alert('Введенный адрес не является адресом электронной почты. Повторите ввод!');
                return;
            }
        }
        const body = { ...command };
        body.commandParams = {};
        command.commandParams.forEach(param => {
            if (param.type === 'date') {
                // eslint-disable-next-line no-param-reassign
                param.value = dayjs(param.value).format('YYYY/MM/DD');
            }
            body.commandParams[param.name] = param.value;
        });
        this.props.runCommand(body);
    };

    handleInput = (e, commandParameter) => {
        const { state } = this;
        const idx = state.command.commandParams.indexOf(commandParameter);
        state.command.commandParams[idx].value = e.target.value;
        this.setState({
            ...state,
        });
    };

    renderInputElement(commandParameter) {
        let element = '';
        const {
            command,
        } = this.state;
        switch (commandParameter.type) {
            case 'checkbox':
                element = (
                    <CommandElementContainer key={commandParameter.name}>
                        <Label>
                            <LabelText>{commandParameter.description}</LabelText>
                            <input
                                type={commandParameter.type}
                                id={commandParameter.name}
                                name={commandParameter.name}
                                value={commandParameter.value === true ? 'on' : 'off'}
                                onChange={() => this.handleCheckbox(commandParameter)}
                                checked={commandParameter.value}
                            />
                        </Label>
                    </CommandElementContainer>
                );
                break;

            case 'date':
                element = (
                    <CommandElementContainer key={commandParameter.name}>
                        <Label>
                            <LabelText>
                                {commandParameter.description}
                            </LabelText>
                            <Calendar handleCalendar={(e) => { this.handleCalendar(e, commandParameter); }} value={dayjs(commandParameter.value).toDate()} />
                        </Label>
                    </CommandElementContainer>
                );
                break;

            case 'select':
                element = (
                    <CommandElementContainer key={commandParameter.name}>
                        <Label>
                            <LabelText>
                                {commandParameter.description}
                            </LabelText>
                            <Select
                                options={commandParameter.options}
                                handleMerchantChange={(e) => this.handleMerchantChange(e, commandParameter)}
                                type={command.command}
                                link={commandParameter.link}
                            />
                        </Label>
                    </CommandElementContainer>
                );
                break;

            case 'maskedInput':
                element = (
                    <CommandElementContainer key={commandParameter.name}>
                        <Label>
                            <LabelText>
                                {commandParameter.description}
                            </LabelText>
                            <input
                                type="text"
                                value={command.commandParams[command.commandParams.indexOf(commandParameter)].value}
                                onChange={(e) => { this.handleInput(e, commandParameter); }}
                            />
                        </Label>
                    </CommandElementContainer>
                );
                break;

            default:
                break;
        }
        return element;
    }

    getDisabled(command) {
        if (command.command === 'operations:sync') {
            const parameter = command.commandParams.filter(param => param.name === 'sector');
            if (parameter[0].value.length === 0) {
                return true;
            }
        }
        return false;
    }

    render() {
        const {
            commandState: {
                data: {
                    commandStatus,
                    result,
                },
                isLoading,
                isLoaded,
                error,
                commandName,
            },
        } = this.props;

        const {
            command,
        } = this.state;

        const SHOW_STATUS = commandStatus && commandStatus === 'completed' && command.commandName === commandName;
        const SHOW_ERROR = error && error.message.length > 0 && command.commandName === commandName;
        const SHOW_LOADER = isLoading && !isLoaded && command.commandName === commandName;
        const DISABLE_BUTTON = isLoading || this.getDisabled(command);

        return (
            <CommandContainer label={command.commandName}>
                <p>{command.commandDesc}</p>
                {command.commandParams.map(param => this.renderInputElement(param))}
                <CommandInteractionContainer>
                    <button type="button" onClick={this.handleClick} disabled={DISABLE_BUTTON}>Сформировать</button>
                    {SHOW_STATUS && <span>Выполнение команды {command.commandName} успешно завершено</span>}
                    {SHOW_ERROR && <span>Выполнение команды {command.commandName} завершено с ошибкой. Сведения об ошибке: {error.message}</span>}
                    {SHOW_LOADER && <span>...Loading</span>}
                </CommandInteractionContainer>
                {result && command.command === 'test:gen:payment' && true && <a href={result} target="__blank">{result}</a>}
            </CommandContainer>
        );
    }
}

export default connect(
    state => ({
        commandState: state.app.commandState,
    }),

    {
        runCommand,
    },

)(Command);
